import React, { useEffect, useState } from "react";
import {Box, Input, styled } from "@mui/material";
import { theme, Badge } from "@material-ui/core";
import Select from "react-select";

export const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...base,
      backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
      //backgroundColor: isFocused ? "#6BD5C0" : "#320B63",
    };
  }
};
  //

export const StyledBox= styled(Box)({
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "10px",
  })


export const StyledInput= styled(Input)({
    width: "100%",
    fontSize: "14px",
    //fontColor: "black",
    height: "95%",
    marginBottom: "2px",
    marginTop: "2px",
  })
  
export const StyledSelect= styled(Select)({
    width: "100%",
    fontSize: "14px",
    fontColor: "white",
    height: "95%",
    marginBottom: "2px",
    marginTop: "2px",
  })

export const TXTRoundedDiv = styled("div")(({ theme }) => ({
    backgroundColor: "",
    border: '1px solid #6BD5C0',
    //borderColor: "#6BD5C0",
    /** 
     * #6BD5C0
     * #8868B0
     *#320B63
     #01579b
     #4527a0
     #311b92
    **/
    borderRadius: theme.shape.borderRadius,
    width: "100%",
    fontSize: "14px",
    marginBottom: "10px"
  }));
 

 